import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import './HomeSecurityLanding.css';

/* ── Data ─────────────────────────────────────────── */
const SUB_CATEGORIES = [
  { name: 'CCTV Cameras', icon: 'camera', link: '/security-systems/cctv-cameras', count: '240+ Products' },
  { name: 'Smart Locks', icon: 'lock', link: '/security-systems/smart-door-locks', count: '85+ Products' },
  { name: 'Alarm Systems', icon: 'alarm', link: '/security-systems/access-control', count: '130+ Products' },
  { name: 'Motion Sensors', icon: 'sensor', link: '/security-systems/cctv-accessories', count: '96+ Products' },
  { name: 'Video Doorbells', icon: 'doorbell', link: '/security-systems/video-door-phones', count: '45+ Products' },
  { name: 'NVR / DVR Systems', icon: 'dvr', link: '/security-systems/cctv-combo-kits', count: '72+ Products' },
  { name: 'Smoke Detectors', icon: 'smoke', link: '/security-systems/cctv-accessories', count: '58+ Products' },
  { name: 'Smart Safes', icon: 'safe', link: '/security-systems/access-control', count: '34+ Products' },
];

const BRANDS = [
  { name: 'CP Plus', color: '#E87722' },
  { name: 'Hikvision', color: '#E63946' },
  { name: 'Bosch', color: '#1D3557' },
  { name: 'Honeywell', color: '#E63946' },
  { name: 'Yale', color: '#2A9D8F' },
  { name: 'Godrej', color: '#264653' },
  { name: 'Dahua', color: '#457B9D' },
  { name: 'Axis', color: '#1D3557' },
];

const PRODUCTS = [
  { id: 1, name: 'CP PLUS 2MP Full HD IR Dome Camera 30Mtr Night Vision', brand: 'CP Plus', price: '₹1,855', oldPrice: '₹6,200', off: '70%', rating: 4, reviews: 79811, badge: 'Best Seller' },
  { id: 2, name: 'Hikvision 4MP AcuSense Fixed Turret Network Camera', brand: 'Hikvision', price: '₹3,499', oldPrice: '₹8,000', off: '56%', rating: 4, reviews: 12430, badge: 'Top Rated' },
  { id: 3, name: 'CP PLUS Pan/Tilt Wi-Fi CCTV Camera with Cloud Storage', brand: 'CP Plus', price: '₹2,199', oldPrice: '₹5,499', off: '60%', rating: 4, reviews: 34200, badge: 'Deal of the Day' },
  { id: 4, name: 'Yale Smart Door Lock with Fingerprint & PIN Code', brand: 'Yale', price: '₹8,499', oldPrice: '₹14,999', off: '43%', rating: 5, reviews: 8762, badge: 'Top Seller' },
  { id: 5, name: 'Bosch Wireless Alarm System with GSM Module 8-Zone', brand: 'Bosch', price: '₹5,999', oldPrice: '₹11,500', off: '47%', rating: 4, reviews: 5430, badge: 'Top Rated' },
  { id: 6, name: 'Dahua 8CH 4K NVR with 2TB HDD Surveillance Kit', brand: 'Dahua', price: '₹14,999', oldPrice: '₹28,000', off: '46%', rating: 4, reviews: 3210, badge: 'Best Value' },
  { id: 7, name: 'Honeywell Motion Sensor PIR Detector Wireless 12m Range', brand: 'Honeywell', price: '₹1,299', oldPrice: '₹2,800', off: '53%', rating: 4, reviews: 9800, badge: 'Deal of the Day' },
  { id: 8, name: 'CP PLUS Video Doorbell Wi-Fi 1080p with Chime', brand: 'CP Plus', price: '₹3,199', oldPrice: '₹6,999', off: '54%', rating: 4, reviews: 6700, badge: 'New Arrival' },
];

const FEATURES = [
  {
    icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4ABCE8" strokeWidth="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
    title: '100% Genuine Products',
    desc: 'All security products are sourced directly from manufacturers — quality guaranteed.',
  },
  {
    icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#81C862" strokeWidth="1.8"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
    title: 'Pan-India Delivery',
    desc: 'Fast shipping to 20,000+ pincodes. Installation support available in major cities.',
  },
  {
    icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#E87722" strokeWidth="1.8"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.37a2 2 0 0 1 1.99-2.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.92-.92a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
    title: '24/7 Technical Support',
    desc: 'Our security experts help you choose, install, and troubleshoot your system.',
  },
  {
    icon: <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" strokeWidth="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
    title: 'B2B Bulk Pricing',
    desc: 'Special pricing for builders, housing societies, offices, and enterprises.',
  },
];

const GUIDE_STEPS = [
  { step: '01', title: 'Assess Your Space', desc: 'Map out entry points, blind spots, and areas that need 24/7 monitoring.' },
  { step: '02', title: 'Choose the Right System', desc: 'Wired for large properties, wireless for flexibility — or a hybrid approach.' },
  { step: '03', title: 'Select Cameras & Sensors', desc: 'Match resolution, night-vision range, and weatherproofing to your needs.' },
  { step: '04', title: 'Professional Installation', desc: 'Our certified partners install and configure your system end-to-end.' },
];

/* ── Star Rating ─────────────────────────────────── */
const Stars: React.FC<{ rating: number }> = ({ rating }) => (
  <div className="hs-stars">
    {[1,2,3,4,5].map(s => (
      <svg key={s} width="12" height="12" viewBox="0 0 24 24"
        fill={s <= rating ? '#F59E0B' : '#E5E7EB'}
        stroke={s <= rating ? '#F59E0B' : '#E5E7EB'} strokeWidth="1">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ))}
  </div>
);

const SUB_ICONS: Record<string, React.ReactNode> = {
  camera: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>,
  lock: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>,
  alarm: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  sensor: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="3"/><path d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>,
  doorbell: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="17" r="1"/></svg>,
  dvr: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>,
  smoke: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/></svg>,
  safe: <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="12" cy="12" r="3"/><path d="M16.5 7.5l-9 9"/></svg>,
};

const badgeClass = (badge: string) => {
  if (badge === 'Best Seller' || badge === 'Top Seller') return 'hs-badge--teal';
  if (badge === 'Deal of the Day') return 'hs-badge--green';
  if (badge === 'Top Rated') return 'hs-badge--orange';
  return 'hs-badge--purple';
};

/* ── Component ──────────────────────────────────── */
const HomeSecurityLanding: React.FC = () => {
  const productsRef = useRef<HTMLDivElement>(null);

  const scrollProducts = (dir: 'left' | 'right') => {
    if (productsRef.current) {
      productsRef.current.scrollBy({ left: dir === 'left' ? -280 : 280, behavior: 'smooth' });
    }
  };

  return (
    <div className="hsl-page">

      {/* ── Breadcrumb ── */}
      <div className="hsl-breadcrumb-wrap">
        <nav className="hsl-breadcrumb">
          <Link to="/">Home</Link><span>›</span>
          <span className="hsl-breadcrumb__current">Security Systems</span>
        </nav>
      </div>

      {/* ── Hero Banner ── */}
      <section className="hsl-hero">
        <div className="hsl-hero__content">
          <div className="hsl-hero__tag">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            India's #1 Home Security Destination
          </div>
          <h1 className="hsl-hero__title">Secure Your Home<br /><span>with Smart Security</span></h1>
          <p className="hsl-hero__sub">From HD CCTV cameras to smart locks — professional-grade security for every home and business. 500+ brands, 1000+ products.</p>
          <div className="hsl-hero__actions">
            <Link to="/security-systems" className="hsl-hero__cta-primary">Shop All Products</Link>
            <Link to="/security-systems/cctv-cameras" className="hsl-hero__cta-secondary">View CCTV Cameras</Link>
          </div>
          <div className="hsl-hero__stats">
            <div><strong>1000+</strong><span>Products</span></div>
            <div className="hsl-hero__stat-div" />
            <div><strong>500+</strong><span>Brands</span></div>
            <div className="hsl-hero__stat-div" />
            <div><strong>70%</strong><span>Max Discount</span></div>
          </div>
        </div>
        <div className="hsl-hero__visual">
          <div className="hsl-hero__cam-ring">
            <img src="/assets/images/camera.png" alt="Security Camera" className="hsl-hero__cam" />
          </div>
          <div className="hsl-hero__badge-1">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#81C862" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
            HD 4K Night Vision
          </div>
          <div className="hsl-hero__badge-2">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4ABCE8" strokeWidth="2"><path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/><path d="M8 2v16M16 6v16"/></svg>
            AI Motion Detection
          </div>
        </div>
      </section>

      {/* ── Sub-categories grid ── */}
      <section className="hsl-section">
        <div className="hsl-section__header">
          <h2 className="hsl-section__title">Shop by Category</h2>
          <Link to="/security-systems" className="hsl-section__view-all">View All →</Link>
        </div>
        <div className="hsl-subcats">
          {SUB_CATEGORIES.map(cat => (
            <Link to={cat.link} key={cat.name} className="hsl-subcat-card">
              <div className="hsl-subcat-card__icon">{SUB_ICONS[cat.icon]}</div>
              <div className="hsl-subcat-card__name">{cat.name}</div>
              <div className="hsl-subcat-card__count">{cat.count}</div>
            </Link>
          ))}
        </div>
      </section>

      {/* ── Promo banner strip ── */}
      <section className="hsl-promo-strip">
        <div className="hsl-promo-card hsl-promo-card--dark">
          <div>
            <p className="hsl-promo-card__label">LIMITED OFFER</p>
            <h3 className="hsl-promo-card__title">Up to 70% OFF<br />on CCTV Cameras</h3>
            <Link to="/security-systems/cctv-cameras" className="hsl-promo-card__btn">Shop Now →</Link>
          </div>
          <img src="/assets/images/camera.png" alt="CCTV" className="hsl-promo-card__img" />
        </div>
        <div className="hsl-promo-card hsl-promo-card--blue">
          <div>
            <p className="hsl-promo-card__label">B2B SPECIAL</p>
            <h3 className="hsl-promo-card__title">Bulk Orders<br />Get Extra 10% OFF</h3>
            <Link to="/contact" className="hsl-promo-card__btn">Contact Us →</Link>
          </div>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="0.8">
            <rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
          </svg>
        </div>
        <div className="hsl-promo-card hsl-promo-card--green">
          <div>
            <p className="hsl-promo-card__label">INSTALLATION</p>
            <h3 className="hsl-promo-card__title">Free Setup<br />in 50+ Cities</h3>
            <Link to="/contact" className="hsl-promo-card__btn">Book Now →</Link>
          </div>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="0.8">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
        </div>
      </section>

      {/* ── Best Sellers ── */}
      <section className="hsl-section">
        <div className="hsl-section__header">
          <h2 className="hsl-section__title">Best Selling Products</h2>
          <Link to="/security-systems" className="hsl-section__view-all">View All →</Link>
        </div>
        <div className="hsl-products-wrap">
          <button className="hsl-arrow hsl-arrow--left" onClick={() => scrollProducts('left')}>‹</button>
          <div className="hsl-products-track" ref={productsRef}>
            {PRODUCTS.map(p => (
              <Link to={`/product/${p.id}`} key={p.id} className="hsl-prod-card">
                <div className={`hsl-prod-card__badge ${badgeClass(p.badge)}`}>{p.badge}</div>
                <div className="hsl-prod-card__img">
                  <img src="/assets/images/camera.png" alt={p.name} />
                </div>
                <div className="hsl-prod-card__body">
                  <p className="hsl-prod-card__brand">{p.brand}</p>
                  <p className="hsl-prod-card__name">{p.name}</p>
                  <div className="hsl-prod-card__rating">
                    <Stars rating={p.rating} />
                    <span>({p.reviews.toLocaleString()})</span>
                  </div>
                  <div className="hsl-prod-card__prices">
                    <span className="hsl-prod-card__price">{p.price}</span>
                    <span className="hsl-prod-card__old">{p.oldPrice}</span>
                    <span className="hsl-prod-card__off">{p.off} OFF</span>
                  </div>
                  <button className="hsl-prod-card__cart">Add to Cart</button>
                </div>
              </Link>
            ))}
          </div>
          <button className="hsl-arrow hsl-arrow--right" onClick={() => scrollProducts('right')}>›</button>
        </div>
      </section>

      {/* ── Brands ── */}
      <section className="hsl-section hsl-brands-section">
        <h2 className="hsl-section__title" style={{ textAlign: 'center' }}>Top Security Brands</h2>
        <div className="hsl-brands">
          {BRANDS.map(b => (
            <Link to="/security-systems" key={b.name} className="hsl-brand-card">
              <div className="hsl-brand-card__logo" style={{ color: b.color }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill={b.color} stroke="none">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                {b.name}
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* ── Why Choose Us ── */}
      <section className="hsl-why">
        <div className="hsl-why__inner">
          <div className="hsl-why__text">
            <p className="hsl-why__tag">WHY INDUSTRYBULL</p>
            <h2 className="hsl-why__title">Your Trusted Partner<br />for Home Security</h2>
            <p className="hsl-why__sub">We've helped 2.5 lakh+ customers and businesses secure their spaces with top-quality, certified security products.</p>
            <Link to="/security-systems" className="hsl-why__cta">Browse All Security Products →</Link>
          </div>
          <div className="hsl-why__features">
            {FEATURES.map(f => (
              <div key={f.title} className="hsl-why__feat">
                <div className="hsl-why__feat-icon">{f.icon}</div>
                <div>
                  <h4 className="hsl-why__feat-title">{f.title}</h4>
                  <p className="hsl-why__feat-desc">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Buying Guide ── */}
      <section className="hsl-section">
        <div className="hsl-section__header">
          <h2 className="hsl-section__title">Security Buying Guide</h2>
          <span className="hsl-section__sub">Set up your security system in 4 simple steps</span>
        </div>
        <div className="hsl-guide">
          {GUIDE_STEPS.map(g => (
            <div key={g.step} className="hsl-guide-card">
              <div className="hsl-guide-card__step">{g.step}</div>
              <h4 className="hsl-guide-card__title">{g.title}</h4>
              <p className="hsl-guide-card__desc">{g.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section className="hsl-cta">
        <div className="hsl-cta__inner">
          <div className="hsl-cta__text">
            <h2>Need Help Choosing the Right Security System?</h2>
            <p>Our security experts will guide you — completely free. Call us or drop a message.</p>
          </div>
          <div className="hsl-cta__actions">
            <Link to="/contact" className="hsl-cta__btn-primary">Talk to an Expert</Link>
            <Link to="/security-systems" className="hsl-cta__btn-secondary">Browse Products</Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default HomeSecurityLanding;
